import { api } from 'api';
import { call, put, SagaReturnType } from 'redux-saga/effects';
import { fileActions } from 'store/data/file';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Fetches a page of integration files. Dispatches the resulting normalized
// File domain itself, and returns pagination so the caller (the page saga)
// can update the Integrations page state without this operation having to
// import from pages/Integrations/_store (which would create a cycle).
export function* fetchFiles(args: { pageNumber: number; pageSize: number }) {
  function* work(tenantId: string) {
    const { fileDomain, pagination }: SagaReturnType<typeof api.getFiles> =
      yield call(api.getFiles, { tenantId, ...args });

    yield put(fileActions.setDomain(fileDomain));
    return pagination;
  }

  const pagination: SagaReturnType<typeof work> = yield call(
    operationWrapper,
    work,
    JwtFeature.Internal,
  );
  return pagination;
}
